import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SourceResponseModel } from '../models/source-response-model';
import { SourcesService } from '../sources.service';

@Component({
    selector: 'edit-source',
    standalone: true,
    imports: [CommonModule, FormsModule],
    providers: [SourcesService],
    templateUrl: './edit-source.component.html'
})
export class EditSourceComponent implements OnInit {
    @Input() source: SourceResponseModel;
    @Input() isNew: boolean = false;

    public model: SourceResponseModel;
    public isSaving: boolean = false;
    public errorMessage: string = '';

    constructor(
        public activeModal: NgbActiveModal,
        private sourcesService: SourcesService
    ) {}

    ngOnInit(): void {
        if (this.isNew) {
            this.model = {
                publishingSource: '',
                isActive: true,
                description: '',
                businessContactEmail: '',
                technicalContactEmail: '',
                serviceNowGroup: ''
            };
        } else {
            this.model = { ...this.source };
        }
    }

    public save() {
        this.isSaving = true;
        this.errorMessage = '';

        if (this.isNew) {
            this.sourcesService.create(this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to create the source. Please try again.';
                }
            });
        } else {
            this.sourcesService.update(this.source.publishingSource, this.model).subscribe({
                next: (result) => {
                    this.activeModal.close({ action: 'save', data: result });
                },
                error: (error) => {
                    this.isSaving = false;
                    this.errorMessage = error?.error?.message || error?.message || 'Failed to update the source. Please try again.';
                }
            });
        }
    }

    public cancel() {
        this.activeModal.dismiss('cancel');
    }
}
